import { render, staticRenderFns } from "./userLimits.pug?vue&type=template&id=41a86084&lang=pug&"
import script from "./userLimits.js?vue&type=script&lang=js&"
export * from "./userLimits.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\CVM7Z9V\\OneDrive - Allianz\\Escritorio\\apps\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41a86084')) {
      api.createRecord('41a86084', component.options)
    } else {
      api.reload('41a86084', component.options)
    }
    module.hot.accept("./userLimits.pug?vue&type=template&id=41a86084&lang=pug&", function () {
      api.rerender('41a86084', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/adminGAGLayout/views/userLimits/index.vue"
export default component.exports